import TokenUtils from '../modules/navigation-state/utils/token.utils'

/** Currently hardwired dict of specially available routes for entities.
 * Every entity not contained in this dict will be routed to /configuration/dto-entities
 */
const EntityTypeUrlDict = {
  User: '/administration/user-management',
  Role: '/administration/role-management'
}

/** static class to provide helpful url-related utils. */
export default class EntityUrlsUtils {
  /** Gets the url for the entity-type.
   *  Either the route specially defined for the given entity or if none is defined, a default one (/configuration/dto-entities) */
  static getBaseUrlForEntityType(entityType: string): string {
    if (Object.keys(EntityTypeUrlDict).some((key) => key === entityType)) {
      return EntityTypeUrlDict[entityType]
    }
    return `/configuration/dto-entities`
  }

  /** Get the url for the entity type with the id as path paramter (for usage in typescript) .
   *  If no route is defined, the route to the entity browser (/configuration/dto-entities) with the id as query param will be returned.
   */
  static getEntityUrlWithIdPathParam(entityType: string, id: string): string {
    if (Object.keys(EntityTypeUrlDict).some((key) => key === entityType)) {
      return EntityTypeUrlDict[entityType]
    }
    return `/configuration/dto-entities?type=${entityType}&id=${id}`
  }

  /** Determines if a url needs a (entity)-type as query param. */
  static entityUrlNeedsQueryParamType = (entityType: string): boolean =>
    !Object.keys(EntityTypeUrlDict).some((key) => key === entityType)

  /** Generates a URL for a given entity-type to use with the router-link-directive in the html-template.  */
  public static generateUrlForEntityType = (entityType: string): string[] => [
    EntityUrlsUtils.getBaseUrlForEntityType(entityType)
  ]

  /** Generates an object to be used to set query params for the router-link directive in the html-template.  */
  public static generateQueryParamsForEntityType(values: {
    entityType: string
    id?: number
    addToken?: boolean
    checkForQueryParam?: boolean
  }): Object {
    const result = {}

    if (!!values.id) {
      result['id'] = values.id
    }

    if (values.checkForQueryParam !== false && EntityUrlsUtils.entityUrlNeedsQueryParamType(values.entityType)) {
      //  result['type'] = values.entityType;
      // temporary hack for ticket: #2873 - when ticket is fully implemented, this can be removed.
      result['type'] = values.entityType.replace(/Selector$/, '')
    }

    // null and undefined leads to a generated token.
    if (values.addToken !== false) {
      result[TokenUtils.TOKEN_KEY] = TokenUtils.generateToken()
    }

    return result
  }
}
